@if (showEditors && editors$ | async; as editors) {
    @if (editors.length > 0) {
        <div class="p-3 flex flex-row shadow justify-end">
            <div class="bg-gray-300 dark:bg-gray-800 p-3 rounded-lg">
                <span class="mr-2">{{ 'CURRENT_EDITORS' | translate }}</span>
                <span>{{ editors }}</span>
            </div>
        </div>
    }
}
